// extracted by mini-css-extract-plugin
export var Associate = "Associate-module--Associate--IVjxr";
export var Associate__cont = "Associate-module--Associate__cont--1heQ_";
export var Associate__ttl = "Associate-module--Associate__ttl--A575v";
export var Associate__contChld = "Associate-module--Associate__contChld--3NGJu";
export var Associate__sttl = "Associate-module--Associate__sttl--ZEOW-";
export var Associate__text = "Associate-module--Associate__text--3G_i-";
export var Associate__map = "Associate-module--Associate__map--ci8Hj";